import { render, staticRenderFns } from "./ExcelMapperSettingsEditColumns.vue?vue&type=template&id=67c40c90&scoped=true"
import script from "./ExcelMapperSettingsEditColumns.vue?vue&type=script&lang=ts"
export * from "./ExcelMapperSettingsEditColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c40c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c40c90')) {
      api.createRecord('67c40c90', component.options)
    } else {
      api.reload('67c40c90', component.options)
    }
    module.hot.accept("./ExcelMapperSettingsEditColumns.vue?vue&type=template&id=67c40c90&scoped=true", function () {
      api.rerender('67c40c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/excel-mapper/ExcelMapperSettingsEditColumns.vue"
export default component.exports